import * as THREE from "three";
import PlanOrigin from "../../project-organisation/models/plan-origin.ts";

class FragmentRecord {
    name: string;

    filePath: string;

    origin: PlanOrigin;

    sitePosition: THREE.Vector3 | undefined;

    constructor(name: string, filePath: string, origin: PlanOrigin, sitePosition: THREE.Vector3 | undefined) {
        this.name = name;
        this.filePath = filePath;
        this.origin = origin;
        this.sitePosition = sitePosition;
    }
}

export default FragmentRecord;